import { PdaCompany, PdaUser } from '../services/api';

const TOKEN_KEY = 'pda_token';
const USER_KEY = 'pda_user';
const COMPANY_KEY = 'pda_company';

export function getStoredToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function getStoredUser(): PdaUser | null {
  const raw = localStorage.getItem(USER_KEY);

  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw) as PdaUser;
  } catch {
    clearSession();
    return null;
  }
}

export function hasStoredSession() {
  return Boolean(getStoredToken() && getStoredUser());
}

export function getStoredCompany(): PdaCompany | null {
  const raw = localStorage.getItem(COMPANY_KEY);

  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw) as PdaCompany;
  } catch {
    clearStoredCompany();
    return null;
  }
}

export function hasStoredCompany() {
  return Boolean(getStoredCompany());
}

export function storeCompany(company: PdaCompany) {
  localStorage.setItem(COMPANY_KEY, JSON.stringify(company));
}

export function clearStoredCompany() {
  localStorage.removeItem(COMPANY_KEY);
}

export function storeSession(user: PdaUser) {
  localStorage.setItem(TOKEN_KEY, user.token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  clearStoredCompany();
}
